import { jumpLoginPage, jumpActivateLogin } from '@/assets/js/jumpLogin.js'
import axios from 'axios'
import { Message } from 'element-ui'
import Qs from 'qs'

// Tool.getSession()
// http request 拦截器

// 设置默认超时时间为15s， timeoutTips设置为true，会有请求超时的提示，默认不提示
axios.defaults.withCredentials = true
axios.defaults.timeout = 15000

// 用于连续多次点击时，取消之前的请求，之保留最后一次的请求状态
let pending = [] // 声明一个数组用于存储每个正在pending的状态请求
let cancelToken = axios.CancelToken
let removePending = (config, str) => {
  for (let i in pending) {
    if (pending[i].u === config.url + '&' + config.method) {
      // 当当前请求在数组中存在时执行函数体
      pending[i].f() // 执行取消操作
      pending.splice(i, 1)
    }
  }
}

// CC-2298：初值必须读 navigator.onLine，不能写死 true ——
// online/offline 只在状态**翻转**时触发，页面若在已离线状态下加载就永远收不到 offline 事件，
// 写死 true 会让离线期间的请求被放行（发出去必失败，且走不到下面的离线提示分支）[Claude Code]
let internetStatus = typeof navigator !== 'undefined' ? navigator.onLine !== false : true

// ─── CC-2298：网络类提示去重守卫 ──────────────────────────────────────────────
//
// 缺陷：三处网络类提示（internetOffline / serverFailed / timeOut）原本都是裸 Message，
// **每个请求各弹一条**。而页面上一次用户操作往往并发多个请求——RPS 页点一次 Take 就串起 4 个
// （`src/components/VideoButton.vue` 的 startVideo → checkInfo / getDeviceInfo /
// getLocalSDIInfo / sendStartVideo）——于是右上角叠出一摞完全相同的红条。
//
// 守卫：同一 key 在「上一条同 key 提示尚未关闭」期间不再弹。
// - **复位靠 element-ui 的 onClose，不自己复制 duration 常量**：提示活多久由 element-ui 掌握
//   （默认 3s，用户手动关闭也会提前结束），onClose 是唯一事实源；自己写一份 3000 必然漂移。
// - **按 key 隔离，不是全局一把锁**：serverFailed 弹着的时候 timeOut 仍该弹，两者语义不同。
// - **不用 Message.closeAll()**：那会误杀页面上无关的成功/警告提示。
//   同形态先例见 `src/assets/js/toast.js:12` 的 showToast。
const pendingMessageKeys = new Set()
const messageOnce = (key, options) => {
  if (pendingMessageKeys.has(key)) return
  pendingMessageKeys.add(key)
  Message({
    ...options,
    onClose: (...args) => {
      pendingMessageKeys.delete(key)
      if (options.onClose) options.onClose(...args)
    }
  })
}

window.addEventListener('online', () => {
  internetStatus = true
  // CC-2298：网络恢复 = 新的一轮错误纪元，**全部 key 一起复位**（不只是离线那条）。
  // 少了这句，用户「断网→恢复→再断网」时第二次断网将永远静默——去重退化成整会话只弹一次。
  // 清全部而非单条：serverFailed / timeOut 同属网络类，恢复后也该允许重新提示 [Claude Code]
  pendingMessageKeys.clear()
})
window.addEventListener('offline', () => {
  internetStatus = false
})

axios.interceptors.request.use(
  config => {
    if (!internetStatus) {
      // 代表离线 给提示
      // utilVue.$message('') //新实例化的vue实例
      messageOnce('internetOffline', {
        message: i18n.t('lang.internetOffline'),
        type: 'error'
      })
      return false
    }
    if (config.isCancelToken) {
      removePending(config, 'request') // 在一个axios发送前执行一下取消操作
      config.cancelToken = new cancelToken(cancel => {
        // 这里的axios标识用请求地址&请求方式拼接的字符串
        pending.push({ u: config.url + '&' + config.method, f: cancel })
      })
    }
    if ((!config.url.includes('/tvucc-token') && config.url.indexOf('/tvucc') > -1) || config.url.indexOf('/command') > -1 || config.url.indexOf('/tvucc-media') > -1) {
      if (config.method === 'post' && config.data.constructor !== FormData && config.headers['Content-Type'] != 'application/json;charset=UTF-8' && !config.contentType) {
        if (!config.url.includes('/tvucc-user/userDevice/existUserBindDevice')) {
          config.data = Qs.stringify(config.data)
        }
      }
      if (config.headers['Content-Type'] != 'application/json;charset=UTF-8') {
        config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
      }
      if (config.contentType) config.headers['Content-Type'] = config.contentType
    }
    // token page
    if (
      config.url.includes('/tvucc-token') ||
      config.url.includes('/tvucc-user/userDevice/existUserBindDevice')
    ) {
      config.headers['Content-Type'] = 'application/json'
    }
    let urlArr = [
      '/event/getEventById',
      '/event/addEvent',
      '/event/update',
      '/event/delete',
      '/event/listEventByTR',
      '/device/editDeviceName'
    ]
    if (urlArr.includes(config.url)) {
      config.headers['Content-Type'] = 'application/x-www-form-urlencoded'
      config.data = Qs.stringify(config.data)
    }
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

// ─── WR-346：有限重试（惰性基础设施 + 使用约定）────────────────────────────────
//
// 【使用约定（比下面的代码更重要）】
// 1. **任何被路由守卫 `await` 的接口一律不得 opt-in 重试。** 守卫 await 的接口决定首屏白屏窗口，
//    而 opt-in 的成本是乘法：最坏等待 = axios.defaults.timeout(15s) × (retry + 1) + Σ退避。
//    本 ticket 的 initConfig 与 initLoginUser 各踩过一次（各 ≈48s 白屏），这是本单最值钱的教训。
//    恢复手段应该是「给用户一个重试按钮」，不是让他盯着白屏等自动重试。
// 2. 当前**没有任何调用方**声明 `config.retry`（两个初始化接口刻意不用，原因见 src/service/base.js 顶部）。
//    `retryRequest()` 对未声明的请求直接短路，等于不生效。**它不是死代码，别删**（有直测用例）；
//    也别据此以为首屏在重试。
// 3. **只按 GET 设计**。非幂等方法默认不重试（下方白名单）；确要重试非幂等请求须显式 `retryUnsafe: true`，
//    且调用方自负「请求可能已到达服务端并执行过」的风险。
// 4. opt-in 时请自己算总耗时上界，并确认调用点不在任何路由守卫的 await 链上。
//
// 可重试判据：无 response（网络中断 / 客户端超时）或 5xx 才重试；401/402/406 这类鉴权错误重试无意义，
// 取消的请求、离线状态、非幂等方法都不重试 [Claude Code]
const RETRY_UNSAFE_METHODS = ['post', 'put', 'patch', 'delete']
const isRetriableError = error => {
  if (!error) return false
  if (typeof axios.isCancel === 'function' && axios.isCancel(error)) return false
  // 离线：请求拦截器会直接 return false（见上方 internetStatus 分支），产生的错误也没有 response。
  // 重试只会在离线期间反复弹 internetOffline，毫无意义 [Claude Code]
  if (!internetStatus) return false
  const config = error.config || {}
  // 非幂等方法：网络超时时请求**可能已经到达服务端并执行**，重试 = 重复提交 [Claude Code]
  const method = String(config.method || 'get').toLowerCase()
  if (RETRY_UNSAFE_METHODS.indexOf(method) > -1 && !config.retryUnsafe) return false
  if (!error.response) return true
  return Number(error.response.status) >= 500
}

// WR-346：对声明了 config.retry 的请求做有限次指数退避重试，返回重试的 promise；
// 不该重试（未配置 / 次数用尽 / 错误不可重试）时返回 null，由原错误处理链继续。
//
// 重试用的是 config 的**浅拷贝并剥掉 cancelToken**：原 config 已被请求拦截器消费过一轮
// （`cancelToken` 已被用掉、`data` 已被 Qs.stringify、Content-Type 已改写）。剥 cancelToken 是必须的，
// 否则重试复用一个已完成/已取消的 token。**`data` 的二次序列化没有解决**——GET 无 body 所以当前不受影响，
// 走 `retryUnsafe` 重试带 body 的请求前必须先解决它（把原始 data 存一份再复位）[Claude Code]
//
// 退避等待期间仍要响应取消：剥掉的只是塞进 retryConfig 的那份（避免复用已完成 token），
// 原 cancelToken 的引用留一份在闭包里——`removePending` 取消同 url+method 的旧请求时调用的
// 就是它的 cancel()，会 resolve 它的 `.promise`。用 Promise.race 让这份 promise 和退避计时器赛跑，
// 谁先到就按谁处理：取消先到 → 退避结束也不再发起这次重试请求 [Claude Code]
const retryRequest = error => {
  const config = error && error.config
  if (!config || !config.retry) return null
  const tried = config.__retryCount || 0
  if (tried >= config.retry || !isRetriableError(error)) return null
  config.__retryCount = tried + 1
  const delay = (config.retryDelay || 1000) * Math.pow(2, config.__retryCount - 1)
  const originalCancelToken = config.cancelToken
  const retryConfig = Object.assign({}, config)
  delete retryConfig.cancelToken
  const wait = new Promise(resolve => setTimeout(resolve, delay))
  const race = originalCancelToken && originalCancelToken.promise
    ? Promise.race([wait, originalCancelToken.promise])
    : wait
  return race.then(cancelReason => {
    if (cancelReason) return Promise.reject(cancelReason)
    return axios(retryConfig)
  })
}

axios.interceptors.response.use(
  response => {
    if (response.config && response.config.isCancelToken) {
      removePending(response.config, 'response') // 在一个axios响应后再执行一下取消操作，把已经完成的请求从pending中移除
    }
    if (response.data.errorCode === '80000302') {
      window.location.href = response.data.errorInfo
    }
    return response
  },
  error => {
    // WR-346：重试放在所有提示/跳转之前 —— 重试期间不弹超时提示，用尽后才走原有处理 [Claude Code]
    const retrying = retryRequest(error)
    if (retrying) return retrying
    if (error.response) {
      switch (error.response.status) {
        case 406:
        case 402:
        case 401:
          // activate 页走新登录服务专用跳转（hash 路由 #/activate），其余走通用登出
          (window.location.hash || '').indexOf('/activate') > -1 ? jumpActivateLogin() : jumpLoginPage()
          break
        // 超时
        case 504:
          messageOnce('timeOut', {
            message: i18n.t('lang.timeOut'),
            type: 'error'
          })
          break
      }
      // 服务器异常处理
      if ((error.response.status + '').substr(0, 1) == '5' && error.response.status != 504) {
        messageOnce('serverFailed', {
          message: i18n.t('lang.serverFailed'),
          type: 'error'
        })
      }
    }
    if (!error.response) {
      if (error.message && error.message.includes('timeout')) {
        // timeoutTips设置为true，会有请求超时的提示，默认不提示
        if (error.config.timeoutTips) {
          messageOnce('timeOut', { message: i18n.t('lang.timeOut'), type: 'error' })
        }
      }
      return Promise.reject(error)
    }

    return Promise.reject(error.response)
  }
)
export default axios
